export const ACTIONS = {
  SET_PLANET_UI: 'SET_PLANET_UI',
};

export const setPlanetUI = state => ({
  type: ACTIONS.SET_PLANET_UI,
  payload: state,
});
